<div class="full-width row">
    <div [ngClass]="{'left':position == 'left', 'right': position == 'right'}" class="button-wrapper">
        <ng-content></ng-content>
    </div>
</div>
